import { NewOrderFormOrder } from '../New/types'
import { Signer } from './SignersForm/types'
import { validateEmailUniqueness } from 'utils/antFormValidations/validateEmailUniqueness'

export const defaultSigner: Signer = {
  firstName: '',
  lastName: '',
  cellPhone: '',
  additionalPhone: '',
  email: '',
  allowAccessToOrder: true
}

export const generateInitialSigners = (order: NewOrderFormOrder): Signer[] => {
  const initialSigners: Signer[] = []

  // Add primary signer from order fields
  if (order.firstname && order.firstname !== '') {
    const signer: Signer = {
      firstName: order.firstname,
      lastName: order.lastname || '',
      cellPhone: order.mobile_phone || '',
      additionalPhone: order.home_phone || '',
      email: order.signer_email || '',
      allowAccessToOrder: order.signer_allow_access_to_order || false,
      role: 'primary_signer'
    }
    initialSigners.push(signer)
  }

  const hasCoSigner = [
    order.co_first_name,
    order.co_last_name,
    order.co_mobile_phone,
    order.co_home_phone,
    order.co_signer_email
  ].some((field) => field !== undefined && field !== null && field !== '')

  if (hasCoSigner) {
    const co_signer: Signer = {
      firstName: order.co_first_name || '',
      lastName: order.co_last_name || '',
      cellPhone: order.co_mobile_phone || '',
      additionalPhone: order.co_home_phone || '',
      email: order.co_signer_email || '',
      allowAccessToOrder: order.co_signer_allow_access_to_order || false,
      role: 'co_signer'
    }
    initialSigners.push(co_signer)
  }

  // Add any additional co-signers from order.signers with role 'additional_co_signer'
  if (order.signers && order.signers.length > 0) {
    // Find additional co-signers by role
    const additionalCoSigners = order.signers.filter((signer: any) => signer.role === 'additional_co_signer')

    // Add them to initialSigners
    additionalCoSigners.forEach((orderSigner: any) => {
      initialSigners.push({
        firstName: orderSigner.first_name || '',
        lastName: orderSigner.last_name || '',
        cellPhone: orderSigner.mobile_phone || '',
        additionalPhone: orderSigner.home_phone || '',
        email: orderSigner.email || '',
        allowAccessToOrder: false, // Additional co-signers don't have access
        role: 'additional_co_signer'
      })
    })
  }

  // If no signers were added, add a default signer
  if (initialSigners.length === 0) {
    initialSigners.push(defaultSigner)
  }

  return initialSigners
}

// Convenience function for signer email validation
export const validateSignerEmailUniqueness = (currentIndex: number) => {
  return validateEmailUniqueness(currentIndex, 'signers', 'email', 'This email is already used by another signer')
}

const Utils = {
  defaultSigner,
  generateInitialSigners,
  validateSignerEmailUniqueness
}

export default Utils
